import React from 'react';
import classnames from 'classnames';
import { AccentRadioButton } from 'scy/RadioButton';
import { h5, uppercase, accent, secondary } from 'scy/text/styles.mod.scss';
import { textLeft } from 'scy/utils.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';

export default function RadioOption({ checked, children, ...props }) {
  return (
    <AccentRadioButton
      checked={checked}
      containerClass={classnames(padding.left_md, padding.right_md)}
      labelClass={classnames(
        h5,
        uppercase,
        margin.sm,
        textLeft,
        checked ? accent : secondary
      )}
      btnClass={classnames(
        styles.radioButton,
        checked ? null : styles.inactiveRadioButton
      )}
      {...props}
    >
      {children}
    </AccentRadioButton>
  );
}
